<template>
    <tq-loader-container class="TQ_center" :p_show-loader_b="showLoader_b" :p_tq-loader_b="true" >
        <div class="TQ_padding_8px" v-if="!showLoader_b">

            <!-- search quest title-->
            <div>
                <input type="search"
                       :placeholder="ass_strings.oneWord_search[store_system_langCode_ve.val]"
                       class="TQ_padding_8px TQ_maxWidth_320px TQ_width_100p TQ_borderBox TQ_center" v-model="searchQuestTitle_s" @input="m_inputSearchText_f">
            </div>

            <!-- new quest -->
            <tq-card padding="0px"
                     margin="8px"
                     width="100vw"
                     max-width="350px"
                     v-if="server_uds_subscriptionPlanInfo_c"
                     @click.native="m_moveToCreateNewQuest_f()"
                     :selectable="true">

                <div class="TQ_padding_16px TQ_text_20px TQ_text_bold TQ_text_capitalize TQ_text_bold TQ_bg_gray12 TQ_borderRadius_top">
                    <div class="TQ_inline"> {{ ass_strings.threeWords_createNewQuest[store_system_langCode_ve.val] }} </div>
                    <div class="TQ_padding_4px TQ_inline"></div>
                    <div class="TQ_inline TQ_direction_ltr"> ({{co_userQuestsPermissions_owned_ac.length}} / {{server_uds_subscriptionPlanInfo_c.udsspi_maxQuests_n}}) </div>
                </div>

                <div class="TQ_width_250px TQ_center ">
                    <tq-image slot="body" :pb_src_r="ass_img_map_treasure" class="TQ_width_100p "/>
                </div>

            </tq-card>

            <!-- my quest -->
            <tq-card width="100%"
                     max-width="350px"
                     margin="8px"
                     v-for="(questPermission_c, index_n) in co_userQuestsPermissions_owned_ac"
                     :key="'myQuest' + index_n"
                     :selectable="true">

                <tq-quest-explore-header
                    v-if="server_currentUserQuestsExplore_byQuestId_c[questPermission_c.udsqp_questId_uid]"
                    :pb_quest-explore_c="server_currentUserQuestsExplore_byQuestId_c[questPermission_c.udsqp_questId_uid]"
                    :pb_quest-explore-info_c="server_questExploreInfo_byQuestId_c[questPermission_c.udsqp_questId_uid]"
                    :pb_created-user-data_c="server_createdUsersData_byQuestId_c[questPermission_c.udsqp_questId_uid]"

                    :p_system_current-currency_e="store_system_currency_v.val"
                    :ps_lang-code_e="store_system_langCode_ve.val"
                    :ps_screenSize_en="store_system_windowSizeType_ve.val"

                    :pf_small-mode_b="true"
                    :pf_display-active-status_b="true"

                    @click.native="() => {m_clickEditQuest_f(server_currentUserQuestsExplore_byQuestId_c[questPermission_c.udsqp_questId_uid])}"/>

            </tq-card>

            <!-- title - quests with permissions -->
            <div class="TQ_padding_8px TQ_bg_white TQ_text_24px TQ_margin_top_16px" v-if="co_userQuestsPermissions_notOwned_ac.length > 0">
                <!--Quests With Access-->
            </div>

            <!-- quests with permissions -->
            <tq-card width="100%"
                     max-width="350px"
                     margin="8px"
                     v-for="(questPermission_c, index_n) in co_userQuestsPermissions_notOwned_ac"
                     :key="'otherQuest' + index_n"
                     :selectable="true">

                <tq-quest-explore-header
                    v-if="server_currentUserQuestsExplore_byQuestId_c[questPermission_c.udsqp_questId_uid]"
                    :pb_quest-explore_c="server_currentUserQuestsExplore_byQuestId_c[questPermission_c.udsqp_questId_uid]"
                    :pb_quest-explore-info_c="server_questExploreInfo_byQuestId_c[questPermission_c.udsqp_questId_uid]"
                    :pb_created-user-data_c="server_createdUsersData_byQuestId_c[questPermission_c.udsqp_questId_uid]"

                    :p_system_current-currency_e="store_system_currency_v.val"
                    :ps_lang-code_e="store_system_langCode_ve.val"
                    :ps_screenSize_en="store_system_windowSizeType_ve.val"

                    :pf_small-mode_b="true"
                    :pf_display-active-status_b="true"

                    @click.native="() => {m_clickEditQuest_f(server_currentUserQuestsExplore_byQuestId_c[questPermission_c.udsqp_questId_uid])}"/>

            </tq-card>

        </div>
    </tq-loader-container>
</template>

<script>

    import TqQuestExploreHeader from '../../../components/complex/TqQuestExploreHeader'
    import TqCard from '../../../components/basic/TqCard'
    import {
        serverBig_questExplore_once_f,
    } from "@/scripts/Server/S_ServerFirestore";
    import {store_var, store_getStateValue_vo} from "../../../store";
    import {route_moveToRoute, route_moveToRoute_withData_f} from "../../../router";
    import {
        server_getQuestExploreInfo_f,
        serverPre_subUserData_creatorPaymentInfo_get_f,
        serverPre_subUserData_subscriptionPlanInfo_get_f,
        serverPre_userDataSub_questPermission_get_withUserId_f
    } from "../../../scripts/Server/S_ServerPre";
    import {
        enum_moreInfo_featuresIds_s, enum_moreInfoImgOptions_e,
        enum_moveToOptions,
        enum_questPermission_n
    } from "../../../../functions/src/shareCode/Share_S_Enum";
    import {obj_forEach_f} from "../../../../functions/src/shareCode/Share_S_Obj";
    import {
        serverAuth_currentUserData_get_vl_fp,
        serverAuth_currentUserData_remove_vl_f,
        serverAuth_getOtherUserData_f
    } from "../../../scripts/Server/S_ServerAuth";
    import TqLoaderContainer from "@/components/basic/TqLoaderContainer";
    import TqImage from "@/components/basic/TqImage";
    import {
        ass_img_add_b,
        ass_img_add_w,
        ass_img_edit_b,
        ass_img_map_treasure,
    } from "@/assets/scripts/Ass_Files";
    import TqPopup from "@/components/basic/TqPopup";
    import {ass_strings} from "../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import TqOnTopContainer from "@/components/basic/TqOnTopContainer";
    import TqMoreInfo from "@/components/basic2/TqMoreInfo";
    import {FB_QuestPointer} from "../../../../functions/src/shareCode/Share_S_Classes";
    export default {
        name: "V_Creator_EditQuests_List",
        components:{
            TqMoreInfo,
            TqOnTopContainer,
            TqPopup,
            TqImage,
            TqLoaderContainer,
            TqQuestExploreHeader,
            TqCard,
        },
        data(){
            return {

                searchQuestTitle_s          : '',
                showLoader_b                : true,
                lastTimeOutId_s             : null,
                filteredBySearch_byQuestId_b: {},
                inputActionWaitMilSec_n     : 200,

                // store
                store_system_langCode_ve        : store_getStateValue_vo(store_var.system_langCode),
                store_system_windowSizeType_ve  : store_getStateValue_vo(store_var.system_windowSizeType_e),
                store_system_currency_v         : store_getStateValue_vo(store_var.system_currency),
                enum_moreInfo_featuresIds_s     : enum_moreInfo_featuresIds_s,

                // server
                server_currentUserData_c    : undefined,
                server_uds_questPermissions_ac    : [],
                server_uds_subscriptionPlanInfo_c    : undefined,
                server_createdUsersData_byQuestId_c: {},
                server_questExploreInfo_byQuestId_c: {},
                server_currentUserQuestsExplore_byQuestId_c : {},

                // import
                ass_img_edit_b : ass_img_edit_b,
                ass_img_add_b : ass_img_add_b,
                ass_img_add_w : ass_img_add_w,
                ass_strings : ass_strings,
                ass_img_map_treasure : ass_img_map_treasure,
                enum_moreInfoImgOptions_e : enum_moreInfoImgOptions_e,

            }
        },
        computed: {

            co_userQuestsPermissions_owned_ac(){
                return this.server_uds_questPermissions_ac.filter(uds_questPermission_c => !this.filteredBySearch_byQuestId_b[uds_questPermission_c.udsqp_questId_uid] && uds_questPermission_c.udsqp_permission_n === enum_questPermission_n.owner)
            },
            co_userQuestsPermissions_notOwned_ac(){
                return this.server_uds_questPermissions_ac.filter(uds_questPermission_c => !this.filteredBySearch_byQuestId_b[uds_questPermission_c.udsqp_questId_uid] && uds_questPermission_c.udsqp_permission_n !== enum_questPermission_n.owner && uds_questPermission_c.udsqp_permission_n >= enum_questPermission_n.editor)
            },
        },
        methods :{
            m_clickEditQuest_f(questExplore){

                let createdQuest_c = new FB_QuestPointer({
                    qp_questId_uid : questExplore.qex_questId_uid,
                    qp_questType_e : questExplore.qex_questType_e
                })

                route_moveToRoute_withData_f(enum_moveToOptions.creator_edit_item, createdQuest_c)
            },
            m_moveToCreateNewQuest_f(){
                route_moveToRoute(enum_moveToOptions.creator_edit_create)
            },
            m_inputSearchText_f(){

                clearTimeout(this.lastTimeOutId_s)

                this.lastTimeOutId_s = setTimeout(() => {
                    for(let key in  this.server_currentUserQuestsExplore_byQuestId_c){
                        const questExplore_c = this.server_currentUserQuestsExplore_byQuestId_c[key]
                        const questId_uid = questExplore_c.qex_questId_uid
                        const questName_s = questExplore_c.qex_name_byLangCode_s[this.store_system_langCode_ve.val]
                        if(!questName_s.toLowerCase().includes(this.searchQuestTitle_s.toLowerCase())){
                            this.$set(this.filteredBySearch_byQuestId_b, questId_uid, true)
                        }else{
                            this.$set(this.filteredBySearch_byQuestId_b, questId_uid, false)
                        }
                    }
                }, this.inputActionWaitMilSec_n)


            }
        },

        // ======= vue life circle ========
        mounted(){

            // 1) get currentUserData
            serverAuth_currentUserData_get_vl_fp(this.$options.name, (currentUserData_c) => {
                this.server_currentUserData_c = currentUserData_c

                if(currentUserData_c == null){
                    this.showLoader_b = false
                    return
                }

                serverPre_subUserData_subscriptionPlanInfo_get_f({
                    userId_uid : currentUserData_c.ud_userId_uid,
                    cb_f : (uds_subscriptionPlanInfo_c) => {
                        this.server_uds_subscriptionPlanInfo_c = uds_subscriptionPlanInfo_c
                    }
                })

                serverPre_userDataSub_questPermission_get_withUserId_f({
                    userId_uid: this.server_currentUserData_c.ud_userId_uid,
                    questMinPermission_n : enum_questPermission_n.editor,
                    cb_f : (uds_questPermissions_ac) => {
                        this.showLoader_b = false
                        this.server_uds_questPermissions_ac = uds_questPermissions_ac

                        obj_forEach_f(uds_questPermissions_ac, uds_questPermission_c => {
                            let questId_uid = uds_questPermission_c.udsqp_questId_uid

                            // 3) get quest explore
                            serverBig_questExplore_once_f(questId_uid, false, questExplore_c => {

                                if (!questExplore_c) return

                                // save quest
                                this.$set(this.server_currentUserQuestsExplore_byQuestId_c, questId_uid, questExplore_c)

                                // 4) get quest creator data
                                serverAuth_getOtherUserData_f(questExplore_c.qex_creatorId_uid,
                                    userData_c => {
                                        this.$set(this.server_createdUsersData_byQuestId_c, questId_uid, userData_c);
                                    })

                                // 5) get quest creator data
                                server_getQuestExploreInfo_f(questExplore_c, questExploreInfo_c => {
                                    this.$set(this.server_questExploreInfo_byQuestId_c, questId_uid, questExploreInfo_c);
                                })

                            });
                        })
                    }
                })
            })

        },
        destroyed(){
            // 1) remove currentUserData
            serverAuth_currentUserData_remove_vl_f(this.$options.name)
        },
    }

</script>

<style scoped lang="scss">
</style>